import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Storage {
  setItem(key: string, value: any): void {
    if (typeof window === 'undefined' || !window.localStorage) return;
    const jsonValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encryptedValue = CryptoJS.AES.encrypt(jsonValue, environment.encryptionKey).toString();
    localStorage.setItem(key, encryptedValue);
  }

  getItem(key: string): any {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }

    const encryptedValue = localStorage.getItem(key);
    if (!encryptedValue) {
      return null;
    }

    try {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, environment.encryptionKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedData) {
        return JSON.parse(encryptedValue);
      }

      try {
        return JSON.parse(decryptedData);
      } catch {
        return decryptedData;
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      console.warn(`Storage: Failed to decrypt key "${key}". Trying plain JSON.`);
      try {
        return JSON.parse(encryptedValue);
      } catch {
        return null;
      }
    }
  }

  clear() {
    localStorage.clear();
  }
}
